/**
 * @generated SignedSource<<0abb9494e619d17095c0ec6efc89ce1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingFeedbackModalCreateMutation$variables = {
  clientAnonymousStatus: boolean;
  contents: any;
  noteId: string;
};
export type MeetingFeedbackModalCreateMutation$data = {
  readonly createMeetingFeedback: {
    readonly feedback: {
      readonly context: ReadonlyArray<{
        readonly __typename: "Note";
        readonly eventStart: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }>;
      readonly id: string;
      readonly info: any;
      readonly isMeetingFeedback: boolean;
      readonly records: ReadonlyArray<{
        readonly contents: any | null;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardFeedback">;
    };
    readonly note: {
      readonly id: string;
      readonly meetingFeedbackResponseCount: number;
      readonly stream: {
        readonly isMeetingFeedbackTabEnabled: boolean;
        readonly " $fragmentSpreads": FragmentRefs<"OverviewSection_NoteStream">;
      };
      readonly viewerSentMeetingFeedback: boolean;
    };
  } | null;
};
export type MeetingFeedbackModalCreateMutation = {
  response: MeetingFeedbackModalCreateMutation$data;
  variables: MeetingFeedbackModalCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientAnonymousStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contents"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "clientAnonymousStatus",
    "variableName": "clientAnonymousStatus"
  },
  {
    "kind": "Variable",
    "name": "contents",
    "variableName": "contents"
  },
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerSentMeetingFeedback",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingFeedbackResponseCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackTabEnabled",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "info",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedback",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contents",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventStart",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "onlyMeetingFeedback",
    "value": true
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAnonymous",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v16 = [
  (v4/*: any*/)
],
v17 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingFeedbackModalCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CreateMeetingFeedback",
        "kind": "LinkedField",
        "name": "createMeetingFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OverviewSection_NoteStream"
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackNode",
            "kind": "LinkedField",
            "name": "feedback",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackRecordNode",
                "kind": "LinkedField",
                "name": "records",
                "plural": true,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "context",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "type": "Note",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedbackCardFeedback"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingFeedbackModalCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CreateMeetingFeedback",
        "kind": "LinkedField",
        "name": "createMeetingFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  {
                    "alias": "meetingFeedbackList",
                    "args": (v13/*: any*/),
                    "concreteType": "NonNullFeedbackConnection",
                    "kind": "LinkedField",
                    "name": "feedbackList",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NonNullFeedbackEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeedbackNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "context",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "type": "Note",
                                    "abstractKey": null
                                  },
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "OtherContext",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FeedbackRecordNode",
                                "kind": "LinkedField",
                                "name": "records",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "meetingFeedbackTextSuggestion",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "feedbackList(first:10,onlyMeetingFeedback:true)"
                  },
                  {
                    "alias": "meetingFeedbackList",
                    "args": (v13/*: any*/),
                    "filters": [
                      "onlyMeetingFeedback"
                    ],
                    "handle": "connection",
                    "key": "stream_meetingFeedbackList",
                    "kind": "LinkedHandle",
                    "name": "feedbackList"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStreamUser",
                    "kind": "LinkedField",
                    "name": "viewerNotestreamuser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accessType",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MeetingFeedbackAnalytics",
                    "kind": "LinkedField",
                    "name": "meetingFeedbackAnalytics",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingsFeedbackAnalyticsSatisfaction",
                        "kind": "LinkedField",
                        "name": "satisfaction",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numFeedbackResponses",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numMeetingsWithFeedback",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numMeetings",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "satisfactionCounts",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "veryUnsatisfiedHistory",
                            "plural": true,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "unsatisfiedHistory",
                            "plural": true,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "neutralHistory",
                            "plural": true,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "satisfiedHistory",
                            "plural": true,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "verySatisfiedHistory",
                            "plural": true,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingsFeedbackAnalyticsRatings",
                        "kind": "LinkedField",
                        "name": "ratings",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "agendaGreatCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "agendaNotgreatCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lengthGreatCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lengthNotgreatCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "discussionGreatCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "discussionNotgreatCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackNode",
            "kind": "LinkedField",
            "name": "feedback",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackRecordNode",
                "kind": "LinkedField",
                "name": "records",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "context",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v4/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventEnd",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "type": "Note",
                    "abstractKey": null
                  },
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emoji",
                        "storageKey": null
                      }
                    ],
                    "type": "OtherContext",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v24/*: any*/),
                      (v18/*: any*/),
                      (v21/*: any*/),
                      (v20/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGuest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relationshipToViewer",
                        "storageKey": null
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "start",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "end",
                        "storageKey": null
                      }
                    ],
                    "type": "Event",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDraft",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharedWithMe",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v24/*: any*/),
                  (v18/*: any*/),
                  (v21/*: any*/),
                  (v20/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackRecipientNode",
                "kind": "LinkedField",
                "name": "recipients",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shared",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isArchived",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastSeenByUser",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "responseCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isThreeSixtyParent",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8cabce84c0b86c67c80b448b53dc6497",
    "id": null,
    "metadata": {},
    "name": "MeetingFeedbackModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingFeedbackModalCreateMutation(\n  $noteId: ID!\n  $contents: JSON!\n  $clientAnonymousStatus: Boolean!\n) {\n  createMeetingFeedback(noteId: $noteId, contents: $contents, clientAnonymousStatus: $clientAnonymousStatus) {\n    note {\n      id\n      viewerSentMeetingFeedback\n      meetingFeedbackResponseCount\n      stream {\n        ...OverviewSection_NoteStream\n        isMeetingFeedbackTabEnabled\n        id\n      }\n    }\n    feedback {\n      id\n      info\n      isMeetingFeedback\n      records {\n        contents\n        id\n      }\n      context {\n        __typename\n        ... on Note {\n          eventStart\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on OtherContext {\n          id\n        }\n      }\n      ...FeedbackCardFeedback\n    }\n  }\n}\n\nfragment FeedbackCardFeedback on FeedbackNode {\n  ...FeedbackSubject_item\n  id\n  title\n  type\n  isArchived\n  isDraft\n  lastSeenByUser\n  isMeetingFeedback\n  requestCount\n  responseCount\n  sharedWithMe\n  updatedAt\n  isThreeSixtyParent\n  isAnonymous\n  creator {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n  }\n  recipients {\n    shared\n    user {\n      id\n    }\n    id\n  }\n}\n\nfragment FeedbackSubject_item on FeedbackNode {\n  id\n  type\n  title\n  isDraft\n  sharedWithMe\n  isAnonymous\n  creator {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n  }\n  recipients {\n    user {\n      id\n    }\n    id\n  }\n  context {\n    __typename\n    ... on User {\n      id\n      email\n      image\n      fullName\n      firstName\n      lastName\n      isGuest\n      relationshipToViewer\n    }\n    ... on Event {\n      id\n      title\n      start\n      end\n    }\n    ... on Note {\n      id\n      title\n      eventStart\n      eventEnd\n      url\n    }\n    ... on OtherContext {\n      name\n      emoji\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment OverviewSection_NoteStream on NoteStream {\n  ...SuggestionsCard_NoteStream\n  viewerNotestreamuser {\n    accessType\n    id\n  }\n  meetingFeedbackAnalytics {\n    satisfaction {\n      ...SatisfactionCard_MeetingsFeedbackAnalyticsSatisfaction\n      ...SatisfactionTrend_MeetingsFeedbackAnalyticsSatisfaction\n    }\n    ratings {\n      ...RatingsCard_MeetingsFeedbackAnalyticsRatings\n    }\n  }\n}\n\nfragment RatingsCard_MeetingsFeedbackAnalyticsRatings on MeetingsFeedbackAnalyticsRatings {\n  agendaGreatCount\n  agendaNotgreatCount\n  lengthGreatCount\n  lengthNotgreatCount\n  discussionGreatCount\n  discussionNotgreatCount\n}\n\nfragment SatisfactionCard_MeetingsFeedbackAnalyticsSatisfaction on MeetingsFeedbackAnalyticsSatisfaction {\n  numFeedbackResponses\n  numMeetingsWithFeedback\n  numMeetings\n  satisfactionCounts\n}\n\nfragment SatisfactionTrend_MeetingsFeedbackAnalyticsSatisfaction on MeetingsFeedbackAnalyticsSatisfaction {\n  veryUnsatisfiedHistory {\n    date\n    count\n  }\n  unsatisfiedHistory {\n    date\n    count\n  }\n  neutralHistory {\n    date\n    count\n  }\n  satisfiedHistory {\n    date\n    count\n  }\n  verySatisfiedHistory {\n    date\n    count\n  }\n}\n\nfragment SuggestionsCard_NoteStream on NoteStream {\n  meetingFeedbackList: feedbackList(first: 10, onlyMeetingFeedback: true) {\n    edges {\n      node {\n        id\n        isAnonymous\n        context {\n          __typename\n          ... on Note {\n            eventStart\n            url\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on OtherContext {\n            id\n          }\n        }\n        records {\n          id\n          meetingFeedbackTextSuggestion\n          creator {\n            id\n            image\n            lastName\n            firstName\n            fullName\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc9229834f8ecdd48fc66c3a6ed98a48";

export default node;
